import MetadataSSOMessage from './MetadataSSOMessage'
export default MetadataSSOMessage
